export const TIPO_ARQUIVO_OPTIONS = [
    {label: 'Excel (.xlsx)', value: 1}
];